import React from 'react'
import Image from 'next/image'
import { Text } from '../../styles/Components'
import GioSignature from '../../../public/about-us/gio_sig.svg'
import DaveSignature from '../../../public/about-us/dave_sig.svg'
import { FoundersQuoteWrapper } from './styles'

const QUOTE = '“We started Glamsquad because we wanted to give pros the freedom to work for themselves, while enjoying what they do best. By offering unique opportunities for professional growth, we’re able to attract top talent; and by attracting top talent, we ensure outstanding customer experiences.”'

const FoundersQuote = () => (
  <FoundersQuoteWrapper aria-label="A note from our founders">
    <blockquote className="quote">
      <Text className="quote-text" lineHeight="1.38">{QUOTE}</Text>
    </blockquote>
    <div className="signatures">
      <div className="signature signature-gio">
        <Image
          src={GioSignature}
          alt="Giovanni Vaccaro signature"
          fill
          style={{ objectFit: 'contain', objectPosition: 'left center' }}
          sizes="562px"
        />
      </div>
      <div className="signature signature-dave">
        <Image
          src={DaveSignature}
          alt="David Goldweitz signature"
          fill
          style={{ objectFit: 'contain', objectPosition: 'left center' }}
          sizes="562px"
        />
      </div>
    </div>
  </FoundersQuoteWrapper>
)

export default FoundersQuote
